import * as React from 'react'
import { Field, FieldArray } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import { Input } from 'components/Input/Input'
import FieldArrayRows from 'components/Input/FieldArrayRows'
import { Textarea } from 'components/Input/Textarea'
import Button from 'components/Button'
import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sMarg from 'styles/modules/margins.scss'

const ArrayValueField = props => (
  <div
    className={cn(sLay['layout-column'], sMarg.w100, sMarg.p30, sMarg.mb15)}
    style={{ background: 'rgba(0, 0, 0, 0.03)' }}
  >
    <Field
      component={Input}
      name={`${props.name}.key`}
      label="Script Name"
      validate={[vRequired]}
      info="This should be unique."
    />
    <Field
      component={Textarea}
      name={`${props.name}.value`}
      label="Script"
      display="standard"
      validate={[vRequired]}
      info="Outline what you want the actor to say. You will be billed per word."
    />
  </div>
)

export interface IVoiceCreateScriptStepProps {
  prev: () => void
  setHeadings?: Function
}

export class VoiceCreateScriptStep extends React.Component<IVoiceCreateScriptStepProps> {
  render() {
    const { prev, setHeadings } = this.props

    setHeadings &&
      setHeadings({
        heading: "Ok so we're all ears,",
        subHeading:
          'Now tell us what you want your recording/s to say, this may be done over multiple scripts as required.',
      })

    return (
      <div>
        <Field
          component={Input}
          name="title"
          label="Title"
          validate={[vRequired]}
          info="A title describing this set of scripts. eg) Main IVR"
        />
        <FieldArray
          name="script"
          FieldComponent={ArrayValueField}
          component={FieldArrayRows}
          addText="Add another script"
        />
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button color="tertiary" type="submit">
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateScriptStep/VoiceCreateScriptStep.tsx